"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var LoyaltyBanner = function (_a) {
    var _b = _a.withVipClub, withVipClub = _b === void 0 ? false : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.titleContainer },
            withVipClub && (react_1.default.createElement("h2", { className: styles_module_scss_1.default.subTitle }, t('loyaltyTitleVipClub'))),
            react_1.default.createElement("h1", { className: styles_module_scss_1.default.title }, t('loyaltyTitle')))));
};
exports.default = LoyaltyBanner;
